/*****************************************************************************/
/*  File Name: timeRangeCalculations.js                                      */
/*  Date:      June 27, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the bar that will show the users the calculations 
/*             based on their selection on the timeRangeBar
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
//import * as TIMERANGE from '../../constants/timeRanges';
import { useROIContext } from '../../context/roiContext';
import { convertToCurrency } from '../../functions/convertCurrency';
import styles from './styles/roi.module.scss';
import * as MODES from '../../constants/modes';

function AnnualCalculations({ t }) {
  //Load all of the default component varaibles

  const { totalAnnualRevenue, totalAnnualTreatmentCosts, totalAnnualProfit, roiMode, consumerAnnualPracticeRevenue, consumerAnnualTreatmentCost, consumerAnnualTreatmentProfit } = useROIContext();

  return (
    <Grid item xs={12} container alignItems='center'>
      <Grid item xs={12} sm={4}>
        <Grid item xs={12} className={styles.title}>
          {roiMode === MODES.consumer ? 'Current' : ''} Total Annual
          <br /> Revenue
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(roiMode === MODES.consumer ? consumerAnnualPracticeRevenue : totalAnnualRevenue())}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Grid item xs={12} className={styles.title}>
          {roiMode === MODES.consumer ? 'Current' : ''} Total Annual
          <br /> Costs
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(roiMode === MODES.consumer ? consumerAnnualTreatmentCost : totalAnnualTreatmentCosts())}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Grid item xs={12} className={styles.title}>
          {roiMode === MODES.consumer ? 'Current' : ''} Total Annual <br />
          Profit
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(roiMode === MODES.consumer ? consumerAnnualTreatmentProfit : totalAnnualProfit())}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withTranslation()(AnnualCalculations);
